$(function() {

  var dynamicContentProfile = 'dynamic_content';
  if (window.solrProxyProject == 'hbs_mbp_preview') {
    dynamicContentProfile = 'dynamic_content_preview';
  }

  // dynamic content configuration (block-view)
  $('#dynamic_content.block-view').solrProxy({
    source: window.solrProxyPath,
    template: 'default_listing_block',
    profile: dynamicContentProfile,
    empty: '#dynamic_content_no_result',
    spinner: '#dynamic_content_spinner',
    found: '#dynamic_content_found',
    counter: '#dynamic_content_counter',
    more: '#dynamic_content_more',
    reset: '#dynamic_content_reset',
    show: '#dynamic_content_pagination',
    list: {
      container: '#dynamic_content_list_filter',
      template: 'default_list_filter'
    },
    onsite: {
      template: 'default_search_meta',
      container: '#default_search_meta',
      params: true
    },
    filter: [
      {
        name: 'section',
        template: 'default_filter_section',
        container: '#dynamic_content_filter_section',
        dataDefault: 'data-default',
        type: 'checkbox',
        empty: 'default_empty_filter'
      },
      {
        name: 'categories',
        template: 'default_filter_categories',
        container: '#dynamic_content_filter_categories',
        dataDefault: 'data-default',
        type: 'checkbox',
        empty: 'default_empty_filter'
      },
      {
        name: 'keywords',
        template: 'default_filter_keywords',
        container: '#dynamic_content_filter_keywords',
        dataDefault: 'data-default',
        type: 'checkbox',
        empty: 'default_empty_filter'
      },
      {
        name: 'author',
        template: 'default_filter_author',
        container: '#dynamic_content_filter_author',
        dataDefault: 'data-default',
        type: 'checkbox',
        empty: 'default_empty_filter'
      },
      {
        name: 'page_lastChanged_date[from]',
        template: 'default_filter_date_from',
        container: '#dynamic_content_filter_date_from',
        type: 'text',
        separated: true,
        dataDefault: 'data-default'
      },
      {
        name: 'page_lastChanged_date[to]',
        template: 'default_filter_date_to',
        container: '#dynamic_content_filter_date_to',
        type: 'text',
        separated: true,
        dataDefault: 'data-default'
      }
    ]
  });

  // dynamic content configuration (box-view)
  $('#dynamic_content.box-view').solrProxy({
    source: window.solrProxyPath,
    template: 'default_listing_box',
    profile: dynamicContentProfile,
    empty: '#dynamic_content_no_result',
    spinner: '#dynamic_content_spinner',
    found: '#dynamic_content_found',
    counter: '#dynamic_content_counter',
    more: '#dynamic_content_more',
    reset: '#dynamic_content_reset',
    show: '#dynamic_content_pagination',
    list: {
      container: '#dynamic_content_list_filter',
      template: 'default_list_filter'
    },
    onsite: {
      template: 'default_search_meta',
      container: '#default_search_meta',
      params: true
    },
    filter: [
      {
        name: 'section',
        template: 'default_filter_section',
        container: '#dynamic_content_filter_section',
        dataDefault: 'data-default',
        type: 'checkbox',
        empty: 'default_empty_filter'
      },
      {
        name: 'categories',
        template: 'default_filter_categories',
        container: '#dynamic_content_filter_categories',
        dataDefault: 'data-default',
        type: 'checkbox',
        empty: 'default_empty_filter'
      },
      {
        name: 'keywords',
        template: 'default_filter_keywords',
        container: '#dynamic_content_filter_keywords',
        dataDefault: 'data-default',
        type: 'checkbox',
        empty: 'default_empty_filter'
      },
      {
        name: 'author',
        template: 'default_filter_author',
        container: '#dynamic_content_filter_author',
        dataDefault: 'data-default',
        type: 'checkbox',
        empty: 'default_empty_filter'
      },
      {
        name: 'page_lastChanged_date[from]',
        template: 'default_filter_date_from',
        container: '#dynamic_content_filter_date_from',
        type: 'text',
        separated: true,
        dataDefault: 'data-default'
      },
      {
        name: 'page_lastChanged_date[to]',
        template: 'default_filter_date_to',
        container: '#dynamic_content_filter_date_to',
        type: 'text',
        separated: true,
        dataDefault: 'data-default'
      }
    ]
  });

  // dynamic slider
  $('.dynamic_content_slider').solrProxy({
    source: window.solrProxyPath,
    template: 'default_slider_listing',
    profile: dynamicContentProfile,
    filter: [
      {
        name: 'section',
        dataContainerDefault: 'default-section'
      },
      {
        name: 'categories',
        dataContainerDefault: 'default-categories'
      },
      {
        name: 'keywords',
        dataContainerDefault: 'default-keywords'
      }
    ],
    afterDocs: function() {
      initSlider();
    }
  });

  var onsiteSearchProfile = 'onsite_search';
  if (window.solrProxyProject == 'hbs_mbp_preview') {
    onsiteSearchProfile = 'onsite_search_preview';
  }

  // onsite search configuration
  $('#onsite_search').solrProxy({
    source: window.solrProxyPath,
    rows: 10,
    template: 'onsite_search_listing',
    profile: onsiteSearchProfile,
    empty: '#onsite_search_no_result',
    spinner: '#onsite_search_spinner',
    found: '#onsite_search_found',
    counter: '#onsite_search_counter',
    more: '#onsite_search_more',
    reset: '#onsite_search_reset',
    show: '#onsite_search_pagination',
    sort: {
      name: 'sorting'
    },
    list: {
      container: '#onsite_search_list_filter',
      template: 'default_list_filter'
    },
    onsite: {
      template: 'onsite_search_meta',
      input: '.onsite-search-input',
      container: '#onsite_search_meta'
    },
    filter: [
      {
        name: 'section',
        template: 'onsite_filter_section',
        container: '#onsite_search_filter_section',
        empty: 'default_empty_filter'
      },
      {
        name: 'categories',
        template: 'onsite_filter_categories',
        container: '#onsite_search_filter_categories',
        empty: 'default_empty_filter'
      }
    ]
  });

  var suggestionTerms = new Bloodhound({
    datumTokenizer: Bloodhound.tokenizers.whitespace,
    queryTokenizer: Bloodhound.tokenizers.whitespace,
    remote: {
      url: solrProxyPathTypeahead + '/ta_search?q=%QUERY',
      wildcard: '%QUERY'
    }
  });

  $('.onsite-search-typeahead').typeahead({
    highlight: true,
    minLength: 3,
    hint: false
  },
  {
    name: 'suggestionTerms',
    limit: Number.MAX_VALUE,
    source: suggestionTerms
  }).on('typeahead:selected', function(e, data) {
    $(e.target).closest('form').submit();
  });

});
